
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { SelectionModel } from '@angular/cdk/collections';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { IPDService } from '../Services/ipdServices.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-add-service',
  templateUrl: './add-service.component.html',
  styleUrls: ['./add-service.component.scss']
})
export class AddmissionPackageComponent implements OnInit {

  destroyservice$: Subject<boolean> = new Subject<boolean>();
  private todaysdate = this.authService.getServerDate;
  private displayedColumns: string[] = ['packageName', 'packageAmount', 'packageSelect'];
  private dataSource = new MatTableDataSource<any>();
  private selection = new SelectionModel<any>(true, []);
  private SelectedServiceArray: any = [];

  constructor(private dialog: MatDialog,
    private authService: AuthService, private dashboardService: DashboardService, private ipdService: IPDService
    , private dialogRef: MatDialogRef<AddmissionPackageComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private opdvisitService: OpdVisitService) { }


  ngOnInit(): void {
    this.SelectedServiceArray = [];
    this.todaysdate = this.authService.getServerDate;
    this.ipdService.selectedServiceRow = null;
    var id = this.data.id;
    var Type = this.data.Type;
    var date = this.dashboardService.selecteddate;
    this.getPackageList(Type, id, date);
  }
  ngOnDestroy(): void {
    this.destroyservice$.next(true);
    this.destroyservice$.unsubscribe();
    this.todaysdate = null;
    this.dataSource = null;
    this.selection = null;
  }


  getPackageList(a, b, c) {
    this.ipdService.GetpackageList(a, b, c).pipe(takeUntil(this.destroyservice$)).subscribe(data => {
      this.dataSource.data = data;
      // console.log('package',  this.dataSource.data);
    })
  }



  applyFilter_grid(filterValue) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data?.forEach(row => this.selection.select(row));
  }
  selectRow(row) {
    this.selection.toggle(row);
    let checkarraydata = this.SelectedServiceArray.filter(item => item.pK_PackageId == row.pK_PackageId);
    if (checkarraydata.length > 0) {
      this.SelectedServiceArray = this.SelectedServiceArray.filter(item => item.pK_PackageId != row.pK_PackageId);
    } else {
      this.SelectedServiceArray.push(row);
    }

    this.SelectedServiceArray = this.SelectedServiceArray.reduce((unique, o) => {
      if (!unique.some(obj => obj.packageName === o.packageName && obj.pK_PackageId === o.pK_PackageId)) {
        unique.push(o);
      }
      return unique;
    }, []);
  }

  removeRow(x) {
    const index: number = this.SelectedServiceArray.indexOf(x);
    if (index !== -1) {
      this.SelectedServiceArray.splice(index, 1);
      this.selection.toggle(x);
    }
    // this.SelectedServiceArray.splice(x, 1 );
  }

  saveServices() {

    if (this.SelectedServiceArray.length > 0) {
      this.ipdService.selectedServiceRow = this.SelectedServiceArray;
      this.dialog.closeAll();
    } else {
      this.dashboardService.openSnackBar("Please Select Package", "OK");
    }



  }
  closedialog() {
    this.dialog.closeAll();
    this.SelectedServiceArray = [];
  }


  getrowdata(row: any) {
    this.SelectedServiceArray.push(row);
    this.ipdService.selectedServiceRow = this.SelectedServiceArray;
    this.dialog.closeAll();

  }


}

